var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.5V13H2.5L9.87333 5.62664L7.37333 3.12664L0 10.5ZM11.8067 3.69331C12.0667 3.43331 12.0667 3.01331 11.8067 2.75331L10.2467 1.19331C9.98667 0.933306 9.56667 0.933306 9.30667 1.19331L8.08667 2.41331L10.5867 4.91331L11.8067 3.69331Z",
    fill: "#9AA0A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.ee0d067abcd28f31235ced1e8800025b.svg";
export { ForwardRef as ReactComponent };